import TEALIUM from "../../enums/tealium-enums";
import { track } from "../../util/tealium";
import type { FsiTab } from "../../../components/ActionReports/FsiActionReport/FsiActionReport";

const TAB_CLICK_ACTIONS: Record<FsiTab, string> = {
  inFsi: "in_fsi_program",
  outFsi: "out_of_fsi_program",
};

/**
 * Tracks the FSI Action Report page view on load.
 * page_section: founders_sales_incentive-report, page_category: action_report, page_detail: list_view_{YYYYMM}
 */
export const fsiPageViewTrack = (period: string) => {
  track(
    TEALIUM.U_TAG_METHOD.VIEW,
    "",
    TEALIUM.CATEGORY.FSI_AR,
    TEALIUM.CATEGORY.ACTION_REPORT,
    `list_view_${period}`,
    "",
  );
};

/**
 * Tracks tab click on the FSI Action Report.
 * click_action: in_fsi_program | out_of_fsi_program, click_category: founders_sales_incentive-report, click_detail: same as click_action
 */
export const fsiTabClickTrack = (tab: FsiTab) => {
  const action = TAB_CLICK_ACTIONS[tab];
  track(TEALIUM.U_TAG_METHOD.LINK, TEALIUM.EVENT_NAME.CLICK_ACTION, "", TEALIUM.CATEGORY.FSI_AR, action, action);
};

/**
 * Tracks a sort action, from either a column header click or the Sort modal's Apply button.
 * click_action: sort_{column}_{direction}, click_category: action_report, click_detail: founders_sales_incentive-report
 */
export const fsiSortColumnTrack = (column: string, direction: "asc" | "desc") => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    TEALIUM.CATEGORY.FSI_AR,
    `sort_${column}_${direction}`,
  );
};

/**
 * Tracks opening the Sort modal via the toolbar's sort button.
 * click_action: sort, click_category: founders_sales_incentive-report, click_detail: founders_sales_incentive-report
 */
export const fsiSortButtonTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.FSI_AR,
    TEALIUM.CATEGORY.FSI_AR,
    "sort",
  );
};

/**
 * Tracks ABO profile click.
 * click_action: profile, click_category: founders_sales_incentive-report, click_detail: founders_sales_incentive-report
 */
export const fsiProfileTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.FSI_AR,
    TEALIUM.CATEGORY.FSI_AR,
    "profile",
  );
};

/**
 * Tracks adding an ABO to the watchlist.
 * click_action: add_to_watchlist, click_category: founders_sales_incentive-report, click_detail: founders_sales_incentive-report
 */
export const fsiAddToWatchlistTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.FSI_AR,
    TEALIUM.CATEGORY.FSI_AR,
    "add_to_watchlist",
  );
};

/**
 * Tracks removing an ABO from the watchlist.
 * click_action: remove_from_watchlist, click_category: founders_sales_incentive-report, click_detail: founders_sales_incentive-report
 */
export const fsiRemoveFromWatchlistTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.FSI_AR,
    TEALIUM.CATEGORY.FSI_AR,
    "remove_from_watchlist",
  );
};

/**
 * Tracks phone (call) icon click.
 * click_action: call, click_category: founders_sales_incentive-report, click_detail: founders_sales_incentive-report
 */
export const fsiPhoneIconTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.FSI_AR,
    TEALIUM.CATEGORY.FSI_AR,
    "call",
  );
};

/**
 * Tracks message icon click.
 * click_action: message, click_category: founders_sales_incentive-report, click_detail: founders_sales_incentive-report
 */
export const fsiMessageIconTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.FSI_AR,
    TEALIUM.CATEGORY.FSI_AR,
    "message",
  );
};

/**
 * Tracks search focus/interaction.
 * click_action: search, click_category: action_report, click_detail: FSI
 */
export const fsiSearchTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    TEALIUM.CATEGORY.FSI_AR,
    "search",
  );
};

/**
 * Tracks export button click.
 * click_action: export, click_category: founders_sales_incentive-report, click_detail: founders_sales_incentive-report
 */
export const fsiExportTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.FSI_AR,
    TEALIUM.CATEGORY.FSI_AR,
    "export",
  );
};
